import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as mutations from './mutations'
import signalr from './modules/signalr'
import config from '@/config'
Vue.use(Vuex)

function getScrollbarWidth () {
  const odiv = document.createElement('div')
  const styles = {
    width: '30px',
    height: '30px',
    overflowY: 'scroll',
    position: 'absolute',
    top: 0,
    left: 0
  }
  let i
  for (i in styles) odiv.style[i] = styles[i]
  document.body.appendChild(odiv)
  const scrollbarWidth = odiv.offsetWidth - odiv.clientWidth
  odiv.remove()
  return scrollbarWidth
}

const _auth = window.localStorage.getItem(config.localTokenName)
let authInitState
try {
  authInitState = JSON.parse(_auth)
} catch {
  authInitState = undefined
}

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    auth: authInitState,
    newAdd: false,
    area: undefined,
    orderBrands: [],
    scrollbarWidth: getScrollbarWidth(),
    areas: [], // 省市区
    stAreas: [], // 绩效考核区域
    plainPermissions: [],
    permissions: [],
    privileges: [],
    subSellers: [],
    privilegeLoaded: false,
    orderState: [
      { id: undefined, name: '全部' },
      { id: 1, name: '待确认' },
      { id: 2, name: '待付款' },
      { id: 3, name: '待发货' },
      { id: 4, name: '待收货' },
      { id: 5, name: '已完成' },
      { id: -1, name: '已取消' },
      { id: -2, name: '已退款' }
    ],
    shops: [],
    payTypes: [
      '',
      '支付宝',
      '微信',
      '银联',
      '卖家标记',
      '挂账',
      '余额',
      '企业网银',
      '零元',
      '货到付款'
    ]
  },
  actions,
  mutations,
  modules: {
    signalr
  }
})
